import React from 'react';
import { motion } from 'framer-motion';
import '../styles/pages/About.scss';
import aboutImage from '../assets/images/about-luna.jpg';

const About = () => {
  return (
    <motion.div 
      className="about-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="container">
        <motion.h1
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
        >
          Sobre a Luna Pijamas
        </motion.h1>
        
        <motion.div 
          className="about-content"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <div className="about-image">
            <img src={aboutImage} alt="Luna Pijamas" />
          </div>
          
          <div className="about-text">
            <h2>Nossa História</h2>
            <p>
              A Luna Pijamas nasceu em 2024 do sonho de criar peças que unissem conforto, 
              qualidade e estilo para os momentos de descanso. Fundada por Catarina de Oliveira e Tamires Carvalho, 
              a marca traz em seu DNA a paixão por tecidos de alta qualidade e designs 
              que fazem você se sentir bem, mesmo nos momentos mais relaxados.
            </p>
            
            <h2>Nossa Missão</h2>
            <p>
              Nosso objetivo é proporcionar o melhor conforto para seu descanso com peças 
              feitas de materiais selecionados, produção responsável e designs que 
              combinam elegância e aconchego. Cada pijama é pensado para oferecer bem-estar 
              e fazer parte dos seus momentos especiais de relaxamento.
            </p>
            
            <h2>Nossos Valores</h2>
            <ul>
              <li><strong>Qualidade:</strong> Selecionamos cuidadosamente cada material</li>
              <li><strong>Conforto:</strong> Desenvolvemos modelagens perfeitas para o corpo</li>
              <li><strong>Sustentabilidade:</strong> Comprometidos com práticas responsáveis</li>
              <li><strong>Atenção aos detalhes:</strong> Cada peça é finalizada com cuidado</li>
              <li><strong>Inovação:</strong> Buscamos sempre novos tecidos e tecnologias</li>
            </ul>
          </div>
        </motion.div>
        
        <motion.div 
          className="team-section"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <h2>Nossa Equipe</h2>
          <p>
            A Luna Pijamas conta com uma equipe apaixonada por moda, conforto e bem-estar. 
            Desde o design até a costura, trabalhamos com profissionais talentosos 
            que valorizam a qualidade e o cuidado em cada etapa de produção.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default About; 